<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { Table } from "sveltestrap";
  import data from "../../../Data/ComponentData/DashboardData/Defaultdata/LatestActivity.json";
  import * as SvgIcon from "../../../Data/SvgIcon/SvgIcon";
  import Link from "svelte-link/src/Link.svelte";
  import { Latestactivity,Today, Month, href,} from "../../../utils/Constant/Constant";
</script>

<Col xl="6" class="col-50 box-col-6 des-xl-50">
  <Card cardProps="latest-update-sec">
    <div slot="customheader" class="header-top d-sm-flex align-items-center">
      <h5>{Latestactivity}</h5>
      <div class="center-content">
        <ul class="week-date">
          <li class="font-primary">{Today}</li>
          <li>{Month}</li>
        </ul>
      </div>
    </div>
    <div slot="contentbody">
      <div class="table-responsive">
        <Table class="table-bordernone">
          <tbody>
            {#each data.LatestActivity as latestItem}
              <tr>
                <td>
                  <div class="media">
                    {@html SvgIcon[latestItem.svg]}
                    <div class="media-body">
                      <span>{latestItem.title}</span>
                      <p>{latestItem.time}</p>
                    </div>
                  </div>
                </td>
                {#each latestItem.btn as button}
                  <td>
                    <Link {href} target="_blank">{button.button}</Link>
                  </td>
                {/each}
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>
    </div>
  </Card>
</Col>